import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getApprovalFlowScreen,
  saveAutoBidRule,
} from '@ebalance/proto/bffuser/v1/approval_flow_service-ApprovalFlowService_connectquery'
import { getWorkflowTemplateFormOptions } from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 自動入札ルールの保存 (単一エリア編集 / 全エリア一括編集の両方、
 * SaveAutoBidRuleRequest.areaCodes の件数で区別、 AC-02/AC-03)。
 *
 * 承認フロー本体の保存 (useSaveApprovalFlow) とは独立した RPC。 成功後は
 * 画面データ (自動入札ルールを含む全プロセス設定) を再取得して最新化する。
 * workflow-template-form-options-bff-aggregation design: テンプレート editor
 * の集約 query (`getWorkflowTemplateFormOptions`) の approval_processes 投影
 * も同じ backend 設定 (auto_bid_rules 含む) を投影するため invalidate する。
 */
export function useSaveAutoBidRule(): InvalidatingMutationResultFor<
  typeof saveAutoBidRule
> {
  return useInvalidatingMutation(saveAutoBidRule, [
    createConnectQueryKey({
      schema: getApprovalFlowScreen,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getWorkflowTemplateFormOptions,
      cardinality: 'finite',
    }),
  ])
}
